import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoadingService } from '../../../core/services/loading.service';

/** Overlay de carga a pantalla completa controlado por `LoadingService.show()` / `hide()`. */
@Component({
  selector: 'app-loading-overlay',
  standalone: true,
  imports: [CommonModule, BlockUIModule, ProgressSpinnerModule],
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss']
})
export class LoadingOverlayComponent {
  constructor(public loadingService: LoadingService) {}
}
